export const PAGINATION__DEFAULT_PER_PAGE = 12;



// WEBPACK FOOTER //
// ./src/consts/index.ts